import React, { useEffect, useState } from "react"
import {
  View,
  Text,
  FlatList,
  TouchableOpacity,
  StyleSheet
} from "react-native"
import moment from "moment"
import Feather from "@expo/vector-icons/Feather"
import getPlatformType from "../../helpers/helpers"
import { COLORS } from "../../screens/tenants/tenantOnboarding/screens/components/PropertyDetailsCard"

interface Props {
  flos?: any[]
  onView: (row: any) => void
  onArchive?: (row: any) => void,
  type: string
}

export default function ActiveProjectTable({
  flos = [],
  onView,
  onArchive,
  type
}: Props) {

  const layout = getPlatformType()
  const [list, setList] = useState<any[]>([])

  useEffect(() => {
    setList(flos || [])
  }, [flos])

  const renderItem = ({ item }: any) => {

    const address = item?.displayAddress || "—"
    const title = item?.title || "Untitled"
    const date = moment(item?.createdAt).format("DD/MM/YYYY")
    const issuesCount =
      item?.open_flow_maintenance_issues?.length || 0

    /* ---------------- WEB TABLE ---------------- */
    if (layout === "web") {
      return (
        <View style={styles.row}>
          <Text style={[styles.cell, { flex: 3 }]} numberOfLines={2}>
            {address}
          </Text>

          <Text style={[styles.cell, { flex: 1.5 }]}>
            {title}
          </Text>

          <Text style={[styles.cell, { width: 120 }]}>
            {date}
          </Text>

          <Text style={[styles.cell, { width: 100 }]}>
            {issuesCount}
          </Text>

          <View style={styles.actionRow}>
            <TouchableOpacity
              style={styles.viewBtn}
              onPress={() => onView(item)}
            >
              <Text style={styles.viewText}>VIEW</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.archiveBtn}
              onPress={() => onArchive?.(item)}
            >
              <Text style={styles.archiveText}>{type == "archived" ? "UNARCHIVE" : "ARCHIVE"}</Text>
            </TouchableOpacity>
          </View>
        </View>
      )
    }

    /* ---------------- MOBILE CARD ---------------- */
    return (
      <View style={styles.card}>
        <View style={styles.cardRow}>
          <Feather name="home" size={18} color="#8B5CF6" />
          <Text style={styles.cardAddress} numberOfLines={2}>
            {address}
          </Text>
        </View>

        <Text style={styles.cardTitle}>{title}</Text>

        <View style={styles.cardMetaRow}>
          <Text style={styles.metaText}>{date}</Text>
          <View style={styles.issueBadge}>
            <Text style={styles.issueText}>
              {issuesCount} Issues
            </Text>
          </View>
        </View>

        <View style={styles.mobileActions}>
          <TouchableOpacity
            style={styles.viewBtn}
            onPress={() => onView(item)}
          >
            <Text style={styles.viewText}>VIEW</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.archiveBtn}
            onPress={() => onArchive?.(item)}
          >
            <Text style={styles.archiveText}>{type == "archived" ? "UNARCHIVE" : "ARCHIVE"}</Text>
          </TouchableOpacity>
        </View>
      </View>
    )
  }

  return (
    <View style={styles.container}>

      <Text style={styles.headerTitle}>{type == "completed" ? "Completed Jobs" : type == "archived" ? "Archived Jobs" : "Active Projects"}</Text>

      <Text style={styles.headerSubtitle}>
        {type == "completed" ?
          "Below are a list of maintenance projects which you have completed. These projects are a group of one or more issues that have been reported and completed." :
          type == "archived" ?
            "Below are a list of maintenance projects which you have archived. These projects are a group of one or more issues that have been reported and archived."
            :
            "Below are a list of maintenance projects you have started."}


      </Text>



      {layout === "web" && (
        <View style={styles.headerRow}>
          <Text style={[styles.headerText, { flex: 3 }]}>ADDRESS</Text>
          <Text style={[styles.headerText, { flex: 1.5 }]}>PROJECT TITLE</Text>
          <Text style={[styles.headerText, { width: 120 }]}>DATE</Text>
          <Text style={[styles.headerText, { width: 100 }]}>ISSUES</Text>
          <View style={{ width: 200 }} />
        </View>
      )}

      <FlatList
        data={list}
        keyExtractor={(item) =>
          item.open_flow_maintenance_project_id.toString()
        }
        renderItem={renderItem}
      />

    </View>
  )
}
const styles = StyleSheet.create({

  headerCard: {
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 18,
    marginBottom: 30,
    shadowColor: "#000",
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 4 },
    elevation: 3,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: "700",
    color: "#7D57C1",
    marginBottom: 10,
  },

  headerSubtitle: {
    fontSize: 14,
    color: "#6B7280",
    lineHeight: 22,
    marginBottom: 25,
  },
  container: {
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 20
  },

  /* ---------- WEB TABLE ---------- */

  headerRow: {
    flexDirection: "row",
    paddingBottom: 15,
    borderBottomWidth: 1,
    borderColor: "#E5E7EB"
  },

  headerText: {
    fontSize: 12,
    fontWeight: "700",
    color: "#6B7280"
  },

  row: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 18,
    borderBottomWidth: 1,
    borderColor: "#F3F4F6"
  },

  cell: {
    fontSize: 14,
    color: "#374151"
  },

  actionRow: {
    width: 200,
    flexDirection: "row",
    justifyContent: "space-between"
  },

  viewBtn: {
    backgroundColor: COLORS.primary,
    paddingVertical: 8,
    paddingHorizontal: 18,
    borderRadius: 20
  },

  viewText: {
    color: "#fff",
    fontWeight: "600"
  },

  archiveBtn: {
    backgroundColor: "#22C55E",
    paddingVertical: 8,
    paddingHorizontal: 18,
    borderRadius: 20
  },
  archiveText: {
    color: "#fff",
    fontWeight: "600"
  },
  card: {
    backgroundColor: "#F9FAFB",
    borderRadius: 14,
    padding: 16,
    marginBottom: 16
  },

  cardRow: {
    flexDirection: "row",
    gap: 8,
    alignItems: "center"
  },

  cardAddress: {
    flex: 1,
    fontSize: 15,
    fontWeight: "600",
    color: "#374151"
  },

  cardTitle: {
    marginTop: 10,
    fontSize: 14,
    color: "#6B7280"
  },

  cardMetaRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 12
  },

  metaText: {
    fontSize: 13,
    color: "#6B7280"
  },

  issueBadge: {
    backgroundColor: "#EDE9FE",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 20
  },

  issueText: {
    color: "#7C3AED",
    fontWeight: "600",
    fontSize: 12
  },

  mobileActions: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 15
  }

})
